/**
 * `/notification` hubi event nomlari — backend `NotificationHubEvents` klassi bilan
 * bir xil. Backend'ga yangi event qo'shilsa yoki nom o'zgarsa, shu yerda ham yangilanadi.
 */
export const NotificationHubEvents = {
  /** Umumiy bildirishnomalar (masalan hakamlarga yangi javob varaqasi). */
  ReceiveNotification: 'ReceiveNotification',
  /** Sessiya boshqa joyda ochilganda — ulanish uziladi. */
  ForceLogout: 'ForceLogout',
  /** Javob varaqalarini generatsiya qilish progressi. */
  AnswerSheetGenerationProgress: 'AnswerSheetGenerationProgress',
  /** Javob varaqalarini yuklab olish (zip) progressi. */
  AnswerSheetDownloadProgress: 'AnswerSheetDownloadProgress',
} as const;

export type NotificationHubEvent =
  (typeof NotificationHubEvents)[keyof typeof NotificationHubEvents];
